// extracted by mini-css-extract-plugin
export var container = "styles-module__container___CYgLf";
export var title = "styles-module__title___Iw754";
export var description = "styles-module__description___eKDgL";